import React from 'react'
import { ServicesCard, ServicesCardExternal, ServicesContainer, ServicesH1, ServicesH2, ServicesP, ServicesWrapper, ServicesIcon } from './ServicesElements';
import { useAuth } from '../../context/AuthContext';
const Services = () => {
    const { currentUser } = useAuth();
    return (
        <ServicesContainer id="services">
            <ServicesH1>Our Services</ServicesH1>
            <ServicesWrapper>
                <ServicesCardExternal href="https://mindspace-chatroom.netlify.app/">
                    <ServicesIcon src='./assets/chatroom.svg' />
                    <ServicesH2>Chat Rooms</ServicesH2>
                    <ServicesP>AI monitored chat rooms where your identity is anonymous!</ServicesP>
                </ServicesCardExternal>
                <ServicesCardExternal href="https://mindspace-quiz.netlify.app/" >
                    <ServicesIcon src='./assets/quiz.svg' />
                    <ServicesH2>Quick Test</ServicesH2>
                    <ServicesP>Take a quiz to check your mood and get respective mood music!</ServicesP>
                </ServicesCardExternal>
                <ServicesCardExternal href="https://mindspace-baymax.netlify.app/" >
                    <ServicesIcon src='./assets/chatbot.svg' />
                    <ServicesH2>BayMax</ServicesH2>
                    <ServicesP>Our own NLP chatbot to cheer up your mood anytime!</ServicesP>
                </ServicesCardExternal>
                <ServicesCard to="/gratitude-diary">
                    <ServicesIcon src='./assets/gratitude.svg' />
                    <ServicesH2>Gratitude Diary</ServicesH2>
                    <ServicesP>Safe place to store the things you are happy to have!(Requires Sign In)</ServicesP>
                </ServicesCard>
                {currentUser ? <ServicesCardExternal href="https://mindspace-videocalling.herokuapp.com">
                    <ServicesIcon src='./assets/videocall.svg' />
                    <ServicesH2>Video Chat</ServicesH2>
                    <ServicesP>Our own video chat platform to talk to experts!(Requires Sign In)</ServicesP>
                </ServicesCardExternal> :
                    <ServicesCard to="/signin">
                        <ServicesIcon src='./assets/videocall.svg' />
                        <ServicesH2>Video Chat</ServicesH2>
                        <ServicesP>Our own video chat platform to talk to experts!(Requires Sign In)</ServicesP>
                    </ServicesCard>}
                <ServicesCard to="/blogs">
                    <ServicesIcon src='./assets/motivation.svg' />
                    <ServicesH2>Motivation</ServicesH2>
                    <ServicesP>Access to blogs, articles written by certified professionals!</ServicesP>
                </ServicesCard>
            </ServicesWrapper>
        </ServicesContainer>
    )
}
export default Services
